import React from 'react';

export default function Card({ title, children, className = '' }) {
  return (
    <section className={`card ${className}`}>
      {title ? <div className="card-title">{title}</div> : null}
      <div className="card-body">{children}</div>
    </section>
  );
}
